import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessageWrappedInSpan} from '../misc';

import {
  FACTOR_EMAIL,
  FACTOR_DATE_OF_BIRTH,
  FACTOR_YEAR_OF_BIRTH,
} from '../../utils/variables';

const SecondFactorErrorMsg = (props) => {
  const {event} = props;

  const _renderSecondFactorAuthorisationMessage = (type) => {
    switch (type) {
      case FACTOR_DATE_OF_BIRTH:
        return (
          <>
            <h2>
              <FormattedMessageWrappedInSpan
                id="eventSnSearchPage.unauthorised.secondFactor.birthDateType.title"
                defaultMessage="Date of birth does not match!"
              />
            </h2>
            <p>
              <FormattedMessageWrappedInSpan
                id="eventSnSearchPage.unauthorised.secondFactor.description"
                defaultMessage="Please check your search query. Only the information you used to register for the event will be accepted."
              />
            </p>
          </>
        );
      case FACTOR_YEAR_OF_BIRTH:
        return (
          <>
            <h2>
              <FormattedMessageWrappedInSpan
                id="eventSnSearchPage.unauthorised.secondFactor.yearOfBirthType.title"
                defaultMessage="Year of birth does not match!"
              />
            </h2>
            <p>
              <FormattedMessageWrappedInSpan
                id="eventSnSearchPage.unauthorised.secondFactor.description"
                defaultMessage="Please check your search query. Only the information you used to register for the event will be accepted."
              />
            </p>
          </>
        );
      case FACTOR_EMAIL:
        return (
          <>
            <h2>
              <FormattedMessageWrappedInSpan
                id="eventSnSearchPage.unauthorised.secondFactor.emailType.title"
                defaultMessage="Email does not match!"
              />
            </h2>
            <p>
              <FormattedMessageWrappedInSpan
                id="eventSnSearchPage.unauthorised.secondFactor.description"
                defaultMessage="Please check your search query. Only the information you used to register for the event will be accepted."
              />
            </p>
          </>
        );
      default:
        return null;
    }
  }

  return (
    <div className="row">
      <div className="col-xs-16 col-sm-12 col-sm-offset-2">
        <div className="unauthorised-info-container">
          {_renderSecondFactorAuthorisationMessage(event.secondFactorType.type)}
        </div>
      </div>
    </div>
  )
}


SecondFactorErrorMsg.propTypes = {
  event: PropTypes.object,
};

export default SecondFactorErrorMsg;
